import clsx from 'clsx';
import { type CSSProperties, forwardRef } from 'react';

import { type BaseInputProps } from './types';

export const BaseInput = forwardRef<HTMLDivElement, BaseInputProps>(
  (
    {
      id,
      disabled,
      containerWidth: triggerWidth,
      value,
      onChange,
      renderInputElement,
      LeftIcon,
      RightIcon,
      placeholder,
      size = 'medium',
      variant = 'outlined',
      ...props
    },
    ref,
  ) => {
    return (
      <div
        {...props}
        tabIndex={0}
        ref={ref}
        style={{ '--trigger-width': `${triggerWidth}px` } as CSSProperties}
        data-disabled={disabled || undefined}
        className={clsx('ods-input-base', `ods-input-${size}`, {
          'ods-w-[var(--trigger-width)]': triggerWidth,
          'ods-border-none': variant === 'ghost',
        })}
      >
        {LeftIcon && <LeftIcon className="ods-input-icon" />}
        <div className="ods-input-content" data-placeholder={!value || undefined}>
          {renderInputElement({ id, disabled, value, onChange, placeholder })}
        </div>
        {RightIcon && (
          <RightIcon data-disabled={disabled || undefined} className="ods-input-icon" />
        )}
      </div>
    );
  },
);
